import { useState } from 'react';

import { useActions } from 'utils/hooks';
import { useForm } from 'utils/hooks';
import config from './config';

import * as usersActions from 'store/users/actions';

import UserForm from './UserForm';

const CreateForm = ({ drawer, refetchData }) => {
  const [createUser] = useActions([usersActions.createUser]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { formState, collectValues, isDirty, hasErrors, handleSubmitError } = useForm(config, {});

  const submitForm = async params => {
    setIsSubmitting(true);
    // const res = await createCargo(params);

    // if (res.id) {
    drawer.close();
    //   refetchData({});
    // } else {
    //   handleSubmitError(res);
    // }

    setIsSubmitting(false);
  };

  return (
    <UserForm
      drawer={drawer}
      formState={formState}
      collectValues={collectValues}
      isDirty={isDirty}
      hasErrors={hasErrors}
      submitForm={submitForm}
      isSubmitting={isSubmitting}
    />
  );
};

export default CreateForm;
